import { Box, Button, Card, CardContent, CardHeader, Grid, Table, TableBody, TableCell, TableRow, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getTeam } from "../../master/team/team.api";
import { RootState } from "../../../store";
import { createPerformance } from "../dashboard.api";
import notificationSuccess from "../../../shared/notificationSuccess";
import notificationError from "../../../shared/notificationError";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";

interface InterfaceValues {
    team_id: string;
    value_new: number;
    value_complete: number;
}

export default function DashboardPerformanceAdd(props: {
    onClose: (isReload: boolean) => void;
    date: string;
}) {

    const dispatch = useDispatch();

    const { performanceDetail } = useSelector((state: RootState) => state.dashboard);
    const { teamList } = useSelector((state: RootState) => state.team);

    const [selectedDate, setSelectedDate] = useState<string>(props.date || moment(props.date).format("YYYY-MM-DD"));
    const [values, setValues] = useState<InterfaceValues[]>([]);

    useEffect(() => {
        dispatch<any>(getTeam());
    }, [dispatch]);

    useEffect(() => {
        if (teamList.length > 0) {
            const initialValues: InterfaceValues[] = teamList.map((team: any) => ({
                team_id: team.id,
                value_new: 0,
                value_complete: 0,
            }));
            setValues(initialValues);
        }
    }, [teamList]);

    const getPerfValue = (teamName: string, key: string) => {
        const found = Array.isArray(performanceDetail) && performanceDetail.find((item: any) => item.team_name === teamName);
        return found ? found[key] : 0;
    };

    const handleChange = (team_id: string, field: keyof InterfaceValues, value: number) => {
        setValues((prevValues) =>
            prevValues.map((item) =>
                item.team_id === team_id ? { ...item, [field]: value } : item
            )
        );
    };

    const handleSubmit = () => {
        dispatch<any>(createPerformance(values.map((item) => ({
            ...item,
            date: selectedDate,
        }))))
            .unwrap()
            .then((response: any) => {
                if (response.status === 200) {
                    notificationSuccess("success add daily jobs")
                        .then(() => {
                            props.onClose(true)
                        })
                }
                else {
                    notificationError(response)
                }
            })
    };

    return (
        <Box px={2} overflow={"auto"} maxHeight={"calc(100vh - 200px)"}>
            <Box zIndex={5} bgcolor={"white"} position="sticky" top={0} pb={1} display="flex" justifyContent="space-between">
                <LocalizationProvider dateAdapter={AdapterMoment}>
                    <DesktopDatePicker
                        inputFormat="MM/DD/YYYY"
                        value={selectedDate}
                        onChange={(value) => setSelectedDate(moment(value).format('YYYY-MM-DD'))}
                        renderInput={(params) => <TextField {...params} size="small" required />}
                    />
                </LocalizationProvider>
                <Button variant="contained" onClick={handleSubmit}>Save</Button>
            </Box>
            <Grid container spacing={2} sx={{ my: 1 }}>
                {teamList.map((team: any) => (
                    <Grid item xs={6} key={team.id}>
                        <Card variant="outlined">
                            <CardHeader title={team.name} />
                            <CardContent>
                                <Table size="small">
                                    <TableBody>
                                        <TableRow>
                                            <TableCell sx={{ border: 0 }}>New Today</TableCell>
                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                            <TableCell sx={{ border: 0 }}>
                                                <TextField
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={values.find((item) => item.team_id === team.id)?.value_new || 0}
                                                    onChange={(e) => handleChange(team.id, "value_new", Number(e.target.value))}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: 0 }}>Total New job</TableCell>
                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                            <TableCell sx={{ border: 0 }}>
                                                <TextField
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={getPerfValue(team.name, "value_new_week")}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: 0 }}>Complete today</TableCell>
                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                            <TableCell sx={{ border: 0 }}>
                                                <TextField
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={values.find((item) => item.team_id === team.id)?.value_complete || 0}
                                                    onChange={(e) => handleChange(team.id, "value_complete", Number(e.target.value))}
                                                />
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ border: 0 }}>Complete Weekly</TableCell>
                                            <TableCell sx={{ border: 0 }}>:</TableCell>
                                            <TableCell sx={{ border: 0 }}>
                                                <TextField
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    type="number"
                                                    value={getPerfValue(team.name, "value_complete_week")}
                                                    InputProps={{ readOnly: true }}
                                                />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </CardContent>
                        </Card>
                    </Grid>
                ))}
            </Grid>
        </Box>
    );
}